var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    {
      key: "ba_" + _vm._uid,
      staticClass: "accordion",
      attrs: { id: _vm.identifier },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.legacyItems, function (label) {
        return _vm.useLegacyItems
          ? _c(
              "BaseAccordionItem",
              {
                key: label,
                attrs: { label: label },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "beforeLabel",
                      fn: function () {
                        return [_vm._t("beforeLabel")]
                      },
                      proxy: true,
                    },
                    {
                      key: "afterLabel",
                      fn: function () {
                        return [_vm._t("afterLabel")]
                      },
                      proxy: true,
                    },
                    {
                      key: "beforeContent",
                      fn: function () {
                        return [_vm._t("beforeContent")]
                      },
                      proxy: true,
                    },
                    {
                      key: "afterContent",
                      fn: function () {
                        return [_vm._t("afterContent")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm._t(label),
              ],
              2
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }